import React, { useState, useRef } from "react";
import MainLayout from "../../layout/mainLayout";
import { Row, Col, Form, Modal } from "react-bootstrap";
import "./index.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  formatAmount,
  getCodeFromUrl,
  getParamsFromURL,
  modifyEncodedURLParams,
  renderOrderStatus,
  renderStatus,
  setParamsInURL,
  setRedirectParams,
} from "../../utils/helper";
import dateFormat from "dateformat";
import { useLocation, useNavigate } from "react-router-dom";
import Checkbox from "../../components/common/FormFields/checkbox";
import { useForm } from "react-hook-form";
import { getProductListing, readData, checkCkycStatus } from "../../service/order/orderService";
import { openModal, setSelectValidError } from "../../store/slices/commonSlice";
import { toast } from "react-toastify";
import KycModal from "../home/components/kycModal";
import {
  paymentDetails,
  summaryMap,
} from "../../service/proposal/proposalService";
import Button from "../../components/common/button";
import LegalDocument from "../../components/legalDocumentModal";
import { buyNow, ordersDetails } from "../../utils/router/constant";
import Loader from "../../components/common/loader";
import { api_strapi } from "../../utils/interface";
import RMCard from "../../components/rmCard";
import OrderRestrictionModal from "../../components/common/OrderRestrictionModal";
import { AG_CODE } from "../../utils/commonConstant";

const PaymentSummary = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const [show, setShow] = useState(false);
  const agCode = getCodeFromUrl();
  const [documentData, setDocumentData] = useState([]);
  const codeFromUrl = getCodeFromUrl();
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData,
  );
  const productData = useSelector(
    (state) => state.orders.selectedOrder.productData,
  );
  const formState = useSelector((state) => state.common.formRendererState);
  const summaryDetails = useSelector((state) => state.buyNow.summaryDetails);

  const nav = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showRestrictionModal, setShowRestrictionModal] = useState(false);

  const [kycModalState, setKycModalState] = useState({
    isOpen: false,
    orderId: null,
    memberId: null,
  });
  const [checkingKyc, setCheckingKyc] = useState(false);

  const [statusResultModal, setStatusResultModal] = useState({
    isOpen: false,
    finalStatus: null,
    remarks: "",
    ckycNumber: ""
  });

  const autoCheckingRef = useRef(false);
  const lastCheckedRef = useRef(0);

  const showKyc = detailsData?.show_kyc || detailsData?.showKyc;
  const isKyc = detailsData?.is_kyc;
  const kycStatus = detailsData?.kyc_status;
  const ckycRemarks = detailsData?.ckyc_remarks || detailsData?.kyc_remarks;

  const isKycRequired = showKyc === true && isKyc !== true;
  const isUnderReview =
    kycStatus === "Pending" ||
    kycStatus === "Uploaded" ||
    kycStatus === "Under Review" ||
    kycStatus === "Under_Review" ||
    kycStatus === "In Progress" ||
    kycStatus === "In_Progress";

  const triggerStatusResultModal = (res) => {
    if (!res) return;
    const fStatus = res.final_status;
    const kStatus = res.kyc_status;
    const remarks = res.ckyc_remarks || "";
    const cNum = res.ckyc_number || "";

    if (kStatus === "Completed" || fStatus === "1" || fStatus === "3") {
      setStatusResultModal({
        isOpen: true,
        finalStatus: "success",
        remarks: remarks,
        ckycNumber: cNum
      });
    } else if (kStatus === "Failed" || fStatus === "0") {
      setStatusResultModal({
        isOpen: true,
        finalStatus: "failure",
        remarks: remarks,
        ckycNumber: cNum
      });
    } else if (kStatus === "Pending") {
      setStatusResultModal({
        isOpen: true,
        finalStatus: "pending",
        remarks: remarks,
        ckycNumber: cNum
      });
    }
  };

  const handleKycCheckStatus = async () => {
    const memberId = detailsData?.billing_member_id || detailsData?.member_id || "";
    if (!orderId || !memberId) {
      toast.error("Invalid Order or Member information");
      return;
    }
    setCheckingKyc(true);
    try {
      const res = await checkCkycStatus(memberId, orderId);
      await readData(orderId, "ODR");
      triggerStatusResultModal(res);
    } catch (err) {
      const errMsg = err?.response?.data?.error_message || "Failed to check status";
      toast.error(errMsg);
    } finally {
      setCheckingKyc(false);
    }
  };
  const [restrictionError, setRestrictionError] = useState(null);

  const {
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange",
  });
  const closeModal = () => {
    setShow(false);
  };
  useEffect(() => {
    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location]);

  useEffect(() => {
    if (orderId) {
      readData(orderId, "ODR");
      summaryMap(orderId);
      getProductListing(orderId);

      const stashedMemberId = sessionStorage.getItem("ckyc_member_id");
      const stashedOrderId = sessionStorage.getItem("ckyc_order_id");
      if (stashedMemberId && stashedOrderId && String(stashedOrderId) === String(orderId)) {
        sessionStorage.removeItem("ckyc_member_id");
        sessionStorage.removeItem("ckyc_order_id");
        const memberId = detailsData?.billing_member_id || detailsData?.member_id || stashedMemberId || "";
        if (memberId) {
          checkCkycStatus(memberId, orderId)
            .then((res) => {
              readData(orderId, "ODR");
              triggerStatusResultModal(res);
            })
            .catch((err) => {
              console.error("Failed to check CKYC status on post-return mount:", err);
            });
        }
      }
    }
  }, [orderId]);

  useEffect(() => {
    const handleFocus = () => {
      const memberId = detailsData?.billing_member_id || detailsData?.member_id || "";
      if (isUnderReview && showKyc === true && orderId && memberId) {
        const now = Date.now();
        if (now - lastCheckedRef.current < 5000) return;
        if (autoCheckingRef.current) return;

        autoCheckingRef.current = true;
        lastCheckedRef.current = now;

        checkCkycStatus(memberId, orderId)
          .then((res) => {
            readData(orderId, "ODR");
            triggerStatusResultModal(res);
          })
          .catch((err) => {
            console.error("Failed to auto-refresh KYC status on focus:", err);
          })
          .finally(() => {
            autoCheckingRef.current = false;
          });
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, [kycStatus, showKyc, orderId, detailsData, isUnderReview]);

  useEffect(() => {
    const redirectWithCode = async () => {
      if (detailsData?.redirect_url) {
        let redirectUrlWithParams = `${detailsData.redirect_url}`;
        if (window.location.href !== redirectUrlWithParams) {
          const token = localStorage.getItem("token");
          if (token) {
            redirectUrlWithParams = await modifyEncodedURLParams(
              detailsData.redirect_url,
              "token",
              "add",
              token,
            );
          }
          // window.location.href = redirectUrlWithParams;
          window.location.replace(redirectUrlWithParams);
        }
      }
    };

    redirectWithCode();
  }, [detailsData?.redirect_url, location]);

  const handlePreviousBtn = async () => {
    const paramObject = {
      entityid: detailsData.product_id,
      orderId: orderId,
    };
    const params = await setParamsInURL(location, paramObject);
    nav(`${buyNow}?${params}`);
  };

  const handleFinish = async (e) => {
    e.preventDefault();
    if (isKycRequired) {
      setKycModalState({
        isOpen: true,
        orderId: orderId,
        memberId: detailsData?.billing_member_id || detailsData?.member_id || "",
      });
      return;
    }

    if (formState || agCode === AG_CODE || agCode === "chem") {
      dispatch(setSelectValidError(false));
      setLoader(true);
      try {
        await paymentDetails(orderId, "PMT", "ODR");
        setLoader(false);
      } catch (error) {
        console.error("Payment details error:", error);
        setLoader(false);
        const errorCode = error?.response?.data?.error_code;
        const errorMessage = error?.response?.data?.error_message || "Payment call failed";
        if (errorCode === "ERR_029" || errorCode === "ERR_030") {
          setRestrictionError(error?.response?.data);
          setShowRestrictionModal(true);
        } else if (errorCode === "ERR_015" || errorMessage.toLowerCase().includes("kyc")) {
          setKycModalState({
            isOpen: true,
            orderId: orderId,
            memberId: detailsData.billing_member_id || detailsData.member_id || "",
          });
        } else {
          toast.error(errorMessage);
        }
      }
    } else {
      dispatch(setSelectValidError(true));
    }
  };


  const OpenModal = (value) => {
    const getDocument = async () => {
      try {
        const response = await api_strapi.get(
          `/terms-and-conditions?filters[slug][$eq]=${`${value}-${codeFromUrl}`}&populate=termsAndCondition`,
        );

        if (response.status === 200 && response) {
          setDocumentData(response?.data?.data[0]?.attributes);
        }
      } catch (error) {
        console.error("error fetching document", error);
      }
    };
    getDocument();

    setShow(true);
  };

  const getCoverValue = (orderData) => {
    let cover = 0;
    if (orderData && orderData?.variant_json) {
      const data = JSON.parse(orderData?.variant_json);
      productData.map((proData) => {
        let id = proData?.entityid;
        cover = data[id]?.cover;
        return formatAmount(cover);
      });
    }
    return formatAmount(cover);
  };

  const productType = detailsData.product_type_name;

  return (
    <MainLayout>
      <div className="pay-summary-container">
        <div className="order-info">
          <div className="order-header">
            <div className="order-id">Order ID : {detailsData.code}</div>
            <div className="order-status">
              {renderStatus(detailsData.status)}
            </div>
          </div>
          <div className="order-date">
            Order Date :{" "}
            {detailsData.created_date
              ? dateFormat(detailsData.created_date, "dd mmm yyyy")
              : "-"}
          </div>
        </div>

        {isKycRequired && (
          <div
            className={`kyc-alert-banner mb-3 ${kycStatus === "Failed"
              ? "kyc-banner-failed"
              : isUnderReview
                ? "kyc-banner-review"
                : "kyc-banner-pending"
              }`}
          >
            <div className="kyc-banner-left">
              <div className="kyc-banner-icon-badge">
                {kycStatus === "Failed" ? (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                ) : isUnderReview ? (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                ) : (
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                )}
              </div>
              <div className="kyc-banner-content">
                <div className="kyc-banner-title">
                  {kycStatus === "Failed"
                    ? "KYC Verification Failed"
                    : isUnderReview
                      ? "KYC Verification Under Review"
                      : "KYC Verification Required"}
                </div>
                <div className="kyc-banner-desc">
                  {kycStatus === "Failed"
                    ? (ckycRemarks || "Your KYC verification could not be completed. Kindly try again.")
                    : isUnderReview
                      ? "Your KYC documents are currently under review. Click Check Status to refresh."
                      : "Complete your KYC verification to proceed with the payment."}
                </div>
              </div>
            </div>

            <div className="kyc-banner-actions">
              {kycStatus === "Failed" ? (
                <>
                  <button
                    type="button"
                    className="kyc-btn-secondary"
                    disabled={checkingKyc}
                    onClick={handleKycCheckStatus}
                  >
                    {checkingKyc ? "Checking..." : "Check Status"}
                  </button>
                  <button
                    type="button"
                    className="kyc-btn-primary"
                    onClick={() =>
                      setKycModalState({
                        isOpen: true,
                        orderId: orderId,
                        memberId: detailsData?.billing_member_id || detailsData?.member_id || "",
                      })
                    }
                  >
                    Try Again
                  </button>
                </>
              ) : isUnderReview ? (
                <button
                  type="button"
                  className="kyc-btn-primary"
                  disabled={checkingKyc}
                  onClick={handleKycCheckStatus}
                >
                  {checkingKyc ? "Checking..." : "Check Status"}
                </button>
              ) : (
                <button
                  type="button"
                  className="kyc-btn-primary"
                  onClick={() =>
                    setKycModalState({
                      isOpen: true,
                      orderId: orderId,
                      memberId: detailsData?.billing_member_id || detailsData?.member_id || "",
                    })
                  }
                >
                  Complete KYC
                </button>
              )}
            </div>
          </div>
        )}

        <Form onSubmit={handleFinish}>
          <Row>
            <Col xs="12" lg={9}>
              <div className="product-container">
                <div className="product-card">
                  <div className="card--img ">
                    {productType === "UMBRELLA" ? (
                      // <img src={productData[0]?.oem_media_url} alt="Insurance" />
                      <>
                        {summaryDetails.oems?.map((variant, index) => (
                          <img
                            key={index}
                            src={variant.media_url}
                            alt="Insurance"
                          />
                        ))}
                      </>
                    ) : (
                      <img
                        src={detailsData?.product_logo_url}
                        alt="Insurance"
                      />
                    )}
                  </div>
                  <div className="product-details">
                    <div className="product-name">{detailsData.name}</div>
                  </div>
                  {productType !== "UMBRELLA" ? (
                    <>
                      <div className="product-details-summary">
                        <div className="product-label-cover">Cover</div>
                        <div className="product-value-cover">
                          {getCoverValue(detailsData)}
                        </div>
                      </div>
                      {/* <div className="product-details-summary">
                      <div className="product-label-premium">Premium</div>
                      <div className="product-value-premium">
                        {formatAmount(detailsData.gross_amount)}
                      </div>
                    </div> */}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="product-container">
                <div className="summary-card">
                  <div className="header-container">
                    <Row>
                      <Col
                        className={`${productType === "UMBRELLA" ? "col-md-10" : "col-md-12"
                          }`}
                      >
                        <div className="summary-title">Order Summary</div>
                        <div className="premium-details">Premium Breakup</div>
                      </Col>
                      {productType === "UMBRELLA" ? (
                        <>
                          <Col className="cover-label col-md-1">Cover</Col>
                          <Col className="cover-label col-md-1">Premium</Col>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                  </div>
                  <hr className="divider" />
                  {productData.map((product, index) => {
                    const productDetails =
                      summaryDetails?.[product?.entityid] || {};
                    return (
                      <Row>
                        <Col
                          className={`summary-price ${productType === "UMBRELLA"
                            ? "col-md-10"
                            : "col-md-11"
                            } `}
                        >
                          <div className="summary-content">
                            {/* <div className="card--img">
                            <img
                              src={product.oem_media_url || "default-image.png"}
                              alt={product.name || "Insurance"}
                            />
                          </div> */}
                            <div className="summary-details">
                              <div className="summary-name">{product.name}</div>
                              {productType !== "UMBRELLA" ? (
                                <div className="summary-description">
                                  {product.oem_name || "N/A"}
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </Col>
                        {productType === "UMBRELLA" ? (
                          <>
                            <Col className="text-end col-md-1">
                              <div className="summary-price">
                                {productDetails.cover
                                  ? formatAmount(productDetails.cover.value)
                                  : "N/A"}
                              </div>
                            </Col>
                          </>
                        ) : (
                          <></>
                        )}

                        <Col className="text-end col-md-1">
                          <div className="summary-price">
                            {productDetails.premium
                              ? formatAmount(productDetails.premium.value)
                              : "N/A"}
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                  <hr />
                  <div className="summary-total-premium">
                    <div className="summary-details">
                      <div className="summary-cost">Total Base Premium</div>
                      <div className="summary-cost">
                        {formatAmount(summaryDetails.base)}
                      </div>
                    </div>
                    <div className="summary-details">
                      <div className="summary-cost">GST</div>
                      <div className="summary-cost">
                        {formatAmount(summaryDetails.tax)}
                      </div>
                    </div>
                    <div className="summary-details total-premium">
                      <div className="summary-cost total-label">Total Premium Amount</div>
                      <div className="summary-cost total-value">
                        {formatAmount(summaryDetails.total)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="product-container summary-card">
                <Checkbox
                  rules={{
                    required: true,
                  }}
                  name="statement"
                  className="checkbox-style"
                  control={control}
                  errors={errors}
                  options={[
                    {
                      name: "statement",
                      label:
                        "I/We hereby declare that the above statement and particulars are true and I/we have not suppressed or misstated any material facts and that at the present time I/we have no reason to anticipate any claim being brought against me/us for any negligent act, error or omission on my/our part and agree that this declaration shall be the basis of the contract between me/us and the Insurer. I/we also agree that the indemnity under the insurance shall not be availed for claims arising out of acts of negligence, error or omission or misconduct committed PRIOR to commencement of this insurance",
                    },
                  ]}
                />
                <Checkbox
                  rules={{
                    required: true,
                  }}
                  name="policy"
                  className="checkbox-style"
                  control={control}
                  errors={errors}
                  options={[
                    {
                      name: "policy",
                      label: (
                        <>
                          I have read the{" "}
                          <span
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link-style"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              OpenModal("cancellation-and-refund");
                            }}
                            style={{ cursor: "pointer", color: "blue" }}
                          >
                            Cancellation & Refund
                          </span>{" "}
                          policy
                        </>
                      ),
                      checked: false,
                    },
                  ]}
                />
              </div>
            </Col>
            <Col xs="12" lg={3}>
              <RMCard />
            </Col>
          </Row>
          <div className="button-container">
            <div className="summary-bottom">
              {productType !== "UMBRELLA" && agCode !== AG_CODE && agCode !== "chem" && (
                <Button
                  type="button"
                  variant="primary"
                  className="previous"
                  onClick={() => handlePreviousBtn()}
                  // disabled={!isValid}
                  label="Previous"
                />
              )}
              {(detailsData.status === "PAYMENT_PENDING" ||
                detailsData.status === "PAYMENT_FAILED") && (
                  <div className="d-flex align-items-center gap-3">
                    {isKycRequired && (
                      <span className="text-danger small fw-semibold">
                        KYC must be completed before making the payment.
                      </span>
                    )}
                    <Button
                      type="submit"
                      variant="primary"
                      className="pay"
                      // disabled={!isValid}
                      disabled={loader || isKycRequired}
                      label={
                        loader ? (
                          <Loader
                            className="pay-loader"
                            color={"white"}
                            height={25}
                            width={20}
                          />
                        ) : (
                          `Pay ${formatAmount(
                            detailsData.gross_amount,
                            null,
                            null,
                            null,
                          )}`
                        )
                      }
                    />
                  </div>
                )}
            </div>
            {isKycRequired && (
              <div className="kyc-warning-box mt-3 d-flex align-items-center justify-content-between p-3 rounded border">
                <div className="kyc-warning-text text-start">
                  {!kycStatus || kycStatus === "Not Verified" || kycStatus === "Not_Verified" ? (
                    <>
                      Complete your KYC to continue with the payment
                    </>
                  ) : isUnderReview ? (
                    <>
                      Verification in progress
                    </>
                  ) : kycStatus === "Failed" ? (
                    <>
                      {ckycRemarks || "Verification failed."}
                    </>
                  ) : null}
                </div>
                <div className="kyc-warning-action text-end">
                  {!kycStatus || kycStatus === "Not Verified" || kycStatus === "Not_Verified" ? (
                    <Button
                      type="button"
                      variant="primary"
                      label="Complete KYC"
                      onClick={() =>
                        setKycModalState({
                          isOpen: true,
                          orderId: orderId,
                          memberId: detailsData?.billing_member_id || detailsData?.member_id || "",
                        })
                      }
                    />
                  ) : isUnderReview ? (
                    <Button
                      type="button"
                      variant="primary"
                      label={checkingKyc ? "Checking..." : "Check status"}
                      disabled={checkingKyc}
                      onClick={handleKycCheckStatus}
                    />
                  ) : kycStatus === "Failed" ? (
                    <div className="d-flex gap-2">
                      <Button
                        type="button"
                        variant="secondary"
                        label={checkingKyc ? "Checking..." : "Check status"}
                        disabled={checkingKyc}
                        onClick={handleKycCheckStatus}
                      />
                      <Button
                        type="button"
                        variant="primary"
                        label="Try again"
                        onClick={() =>
                          setKycModalState({
                            isOpen: true,
                            orderId: orderId,
                            memberId: detailsData?.billing_member_id || detailsData?.member_id || "",
                          })
                        }
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </div>
        </Form>
      </div>

      <LegalDocument
        documentData={documentData}
        setShow={openModal}
        show={show}
        closeModal={closeModal}
      />
      <OrderRestrictionModal
        show={showRestrictionModal}
        onHide={() => setShowRestrictionModal(false)}
        errorData={restrictionError}
        entityid={detailsData?.product_id}
        orderId={orderId}
        productName={detailsData?.name}
      />
      <KycModal
        isOpen={kycModalState.isOpen}
        toggle={() => setKycModalState((prev) => ({ ...prev, isOpen: !prev.isOpen }))}
        orderId={kycModalState.orderId}
        memberId={kycModalState.memberId}
        onSuccess={() => {
          if (orderId) {
            readData(orderId, "ODR");
          }
        }}
      />

      <Modal
        show={statusResultModal.isOpen}
        onHide={() => setStatusResultModal((prev) => ({ ...prev, isOpen: false }))}
        centered
        className="kyc-status-result-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="text-center p-4">
          {statusResultModal.finalStatus === "success" && (
            <div className="kyc-result-box success">
              <div className="kyc-badge-gradient success mb-3 mx-auto d-flex align-items-center justify-content-center">
                ✓
              </div>
              <h4 className="modal-title-text mb-2">KYC Verified Successfully</h4>
              <p className="modal-desc-text mb-3">Your Central KYC has been successfully verified.</p>
              {statusResultModal.ckycNumber && (
                <div className="ckyc-pill mb-3">
                  CKYC Number: {statusResultModal.ckycNumber}
                </div>
              )}
              <button
                type="button"
                className="btn btn-gradient-blue w-100"
                onClick={() => setStatusResultModal((prev) => ({ ...prev, isOpen: false }))}
              >
                Continue to Payment
              </button>
            </div>
          )}

          {statusResultModal.finalStatus === "failure" && (
            <div className="kyc-result-box failure">
              <div className="kyc-badge-gradient failure mb-3 mx-auto d-flex align-items-center justify-content-center">
                ✗
              </div>
              <h4 className="modal-title-text text-danger mb-2">KYC Verification Failed</h4>
              <p className="modal-desc-text mb-3">
                {statusResultModal.remarks || "KYC verification failed. Please try again."}
              </p>
              <button
                type="button"
                className="btn btn-secondary w-100"
                onClick={() => setStatusResultModal((prev) => ({ ...prev, isOpen: false }))}
              >
                Close
              </button>
            </div>
          )}

          {statusResultModal.finalStatus === "pending" && (
            <div className="kyc-result-box pending">
              <div className="kyc-badge-gradient pending mb-3 mx-auto d-flex align-items-center justify-content-center">
                ⏳
              </div>
              <h4 className="modal-title-text text-warning mb-2">Verification In Progress</h4>
              <p className="modal-desc-text mb-3">
                Your verification is currently under review by the insurer registry.
              </p>
              <button
                type="button"
                className="btn btn-gradient-blue w-100"
                onClick={() => setStatusResultModal((prev) => ({ ...prev, isOpen: false }))}
              >
                OK
              </button>
            </div>
          )}
        </Modal.Body>
      </Modal>
    </MainLayout>
  );
};

export default PaymentSummary;
